import { colors, zIndexes } from "@packages/uiKit";
import styled, { css } from "styled-components";
import { HeaderSearchForm } from "../../searchForms/HeaderSearchForm";
import { MainNavigation } from "../MainNavigation";

export const StyledDownDesktopHeader = styled.header<{ $isOpen: boolean }>`
  padding-top: 20px;
  padding-bottom: 25px;
  background-color: ${colors.white};

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      position: fixed;
      width: 100%;
      height: 100%;
      z-index: ${zIndexes.modal};
    `}
`;

export const StyledTop = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
`;

export const StyledBottom = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 21px;
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const StyledButtonsSecondary = styled.div`
  display: flex;
  gap: 6px;
`;

export const StyledSearchInputContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledSearchInput = styled(HeaderSearchForm)`
  height: 40px;
`;

export const StyledLogoContainer = styled.div`
  flex-basis: 171px;
`;

export const StyledMainNavigation = styled(MainNavigation)<{
  $isOpen: boolean;
}>`
  margin-top: 35px;
  margin-bottom: 0px;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      margin-bottom: 45px;
    `}
`;
